// The product page's main image: ONE definition of its URL, srcset and sizes,
// shared by the head preload (scripts/prerender-og.mjs, at build time) and the
// React gallery (src/components/pdp/ImageGallery.tsx). If the two differ by a
// single candidate the browser downloads the image twice.
//
// Widths: almost every supplier photo is 1000 px wide, and asking Shopify's CDN
// for more than the source has returns the untouched original JPEG (the old
// 1600w candidate, picked by every 3x phone, was 315 KB on a rug that is
// 205 KB at 800w and 116 KB at 600w). So no candidate goes above 1000.
//
// Sizes: the photo sits in a 4:3 box with object-contain, so a square photo
// shows narrower than the box: about 69vw on phones and on the single-column
// layout up to 1023 px, about 46vw beside the buy panel, 651 px at most.
// Chrome takes the smallest candidate that covers sizes × pixel ratio, so the
// phone value is set a little under the real 69vw on purpose: at 69vw a 390 px
// 3x phone needs 807 px and tips over into 1000w; at 60vw every 3x phone lands
// on 800w (2.7–3x the pixels shown) and every 2x phone on 600w.
export const PDP_IMAGE_WIDTH = 800;
export const PDP_IMAGE_WIDTHS = [400, 600, 800, 1000];
export const PDP_IMAGE_SIZES = "(max-width: 767px) 60vw, (max-width: 1023px) 69vw, (max-width: 1439px) 46vw, 651px";

/** { src, srcset, sizes } for the PDP main image, from one URL builder. */
export function pdpImageSources(url, sizedImage) {
  if (!url) return null;
  return {
    src: sizedImage(url, PDP_IMAGE_WIDTH),
    srcset: PDP_IMAGE_WIDTHS.map((w) => `${sizedImage(url, w)} ${w}w`).join(", "),
    sizes: PDP_IMAGE_SIZES,
  };
}
